export const FETCH_CLIENTS_SUCCESSFUL = "FETCH_CLIENTS_SUCCESSFUL";
export const FETCH_CLIENTS_FAILED = "FETCH_CLIENTS_FAILED";

export const REGISTER_CLIENT_SUCCESSFUL = "REGISTER_CLIENT_SUCCESSFUL";
export const REGISTER_CLIENT_FAILED = "REGISTER_CLIENT_FAILED";

export const UPDATE_CLIENT_SUCCESSFUL = "UPDATE_CLIENT_SUCCESSFUL";
export const UPDATE_CLIENT_FAILED = "UPDATE_CLIENT_FAILED";

export const DELETE_CLIENT_SUCCESSFUL = "DELETE_CLIENT_SUCCESSFUL";
export const DELETE_CLIENT_FAILED = "DELETE_CLIENT_FAILED";
